import getWithToken from './base/get-with-token'

const getCustomerGroups = (params = {}) => getWithToken('/customer-groups')(params)

export default getCustomerGroups
